import { Box } from "@mui/material";
import React from "react";
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/bootstrap.css'

const PhoneNumberInput = ({
  name,
  dialCodeName,
  onChange,
  value,
  label,
  helperText,
  error,
  variant = "rounded",
  ...rest
}) => {
  return (
    <Box
      component='div'
      sx={{
        '&.MuiBox-root .react-tel-input':{
          '.selected-flag.open::before':{
            borderColor: "transparent !important",
            boxShadow:'none'
          },
          '.selected-flag:focus:before':{
            borderColor: "transparent !important",
            boxShadow:'none'
          },
          '.selected-flag:focus:after':{
            borderColor: "transparent !important",
            boxShadow:'none'
          }
        } 
      }}
    >
      <ReactPhoneInput
        value={value}
        {...rest}
        inputProps={{
        name,
        required: true,
        autoFocus: false,
      }} 
      inputStyle={{
        paddingTop:'8px',
        paddingBottom:'8px',
        width:"100%",
        fontSize:'14px',
        // padding: "16px 14px",
        borderColor: error ? "#DC3838" : "#ced4da !important"        
      }}
      buttonStyle={{
        backgroundColor: "transparent",
        borderColor: error ? "#DC3838" : "#ced4da !important",
      }}
      country={"us"}
      specialLabel={label}
      enableSearch
      searchPlaceholder="Enter Phone Number"
      onChange={(value, country) => {
        // Pass both the full number and the number without country code
        onChange?.(value, country);
      }}
    />
    </Box>
  );
};

export default PhoneNumberInput;
